import React, { createContext, useContext } from 'react';

/**
 * The app shell's mobile state (Phase F1, Task 5c, D-55). Below `md` the
 * navigation drawer is MUI's temporary variant, opened by a hamburger in the
 * page header (`LayoutContent`), which is a sibling of the drawer, not a
 * child: this context is how the header reaches the drawer. Above `md`
 * `isBelowMd` is false and the header renders no trigger, so the desktop
 * shell is what it was.
 *
 * The default value is the no-op shell: a page rendered outside `Layout`
 * (login, `inLayout: false` routes) never sees a trigger.
 */
export interface LayoutShell {
  isBelowMd: boolean;
  isMenuOpen: boolean;
  openMenu: () => void;
  closeMenu: () => void;
}

const noop = () => undefined;

export const LayoutShellContext = createContext<LayoutShell>({
  isBelowMd: false,
  isMenuOpen: false,
  openMenu: noop,
  closeMenu: noop,
});

export const LayoutShellProvider: React.FC<React.PropsWithChildren<{ value: LayoutShell }>> = ({
  value,
  children,
}) => <LayoutShellContext.Provider value={value}>{children}</LayoutShellContext.Provider>;

export const useLayoutShell = () => useContext(LayoutShellContext);
